import { Button } from '@mui/material';
import { styled } from '@mui/system';

export const StyledBoardSettingsButton = styled(Button)(({ theme }) => ({
  textWrap: 'nowrap',
  '&.MuiButtonBase-root': {
    minWidth: 'unset',
    gap: theme.spacing(1),
  },
  '& .MuiButton-startIcon': {
    marginLeft: 0,
    marginRight: 0,
  },
}));
